export default __webpack_public_path__ + "static/media/youtube.a18905bd.png";